




























































































































































import Vue from 'vue'
import { PropertyMap } from '@/components/gmap/'
import {
  DataGrid as DataGridInterface,
  DataGridRowStatus,
  DataGridValue,
  DataGridRow,
} from '@/interfaces/grid/DataGrid'
import {
  TestDetailData,
  DetailAdvertisement,
  DetailData,
} from '@/interfaces/valuation/Detail'
import { MapMarker } from '../interfaces/gmap/Map'

export default Vue.extend({
  name: 'detail',
  components: {
    PropertyMap,
  },
  created() {
    if (this.selectedAd === undefined) {
      this.selectedAd = this.TestDetailData.advertisements[0]
    }
  },
  data(): {
    TestDetailData: DetailData
    markers: MapMarker[]
    selectedAd: undefined | DetailAdvertisement
    imageDetail: boolean | string
  } {
    return {
      markers: [
        {
          id: 1,
          position: { lat: 50.08804, lng: 14.42076 },
          icon: require('@/assets/icons/map/pointer–blue.svg'),
          infoWindow: {
            image: require('@/assets/building.jpg'),
            locality: 'Praha 5',
            developer: 'Central Group',
          },
        },
      ],
      TestDetailData,
      selectedAd: undefined,
      imageDetail: false,
    }
  },
  computed: {
    transaction(): any {
      return this.$route.params.transaction
    },
    detailId(): string {
      return this.transaction.transactionID
    },
    priceHistoryData(): DataGridInterface {
      const fields = (
        detailAdvertisement: DetailAdvertisement
      ): DataGridValue[] => {
        return [
          { header: 'ID', value: detailAdvertisement.id, size: 'xs1' },
          {
            header: 'Číslo inzerátu',
            value: detailAdvertisement.uid,
            size: 'xs1',
          },
          {
            header: 'Zaznamenáno',
            value: detailAdvertisement.created,
            size: 'xs2',
          },
          { header: 'Cena', value: detailAdvertisement.price, size: 'xs1' },
          {
            header: 'Hrubá cena',
            value: detailAdvertisement.priceRough,
            size: 'xs1',
          },
          {
            header: 'Upravená cena',
            value: detailAdvertisement.priceModified,
            size: 'xs1',
          },
          {
            header: 'Pozn. k ceně',
            value: detailAdvertisement.priceNote,
            size: 'xs4',
          },
        ]
      }

      const rows = (data: DetailData): { [rowName: string]: DataGridRow } => {
        let i = 0
        const result: { [rowName: string]: DataGridRow } = {}
        for (const ad of data.advertisements) {
          result[i] = {
            fields: fields(ad),
            status: DataGridRowStatus.Enabled,
          }
          i++
        }
        return result
      }

      return {
        rows: rows(this.TestDetailData),
      }
    },
  },
})
